import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Builder from "./Builder";
import Home from "./Home";
import SharedDynamicForm from "./SharedDynamicForm";
import Login from "./Login";
import Register from "./Register";
import PrivateRoute from "./PrivateRoute";
import "./index.css";
import LeadsPage from "./LeadsPage";
import Layout from "./Layout";
import Facebook from "./Facebook";
import LinkedIn from "./LinkedIn";
import WhatsAppPage from "./WhatsAppPage";
import Dialer from "./Dialer";
import Integration from "./integration";
import DialerLogs from "./DialerLogs";
import CampaignDetailsPage from "./CampaignDetailsPage";
import FacebookDialer from "./FacebookDialer";

export default function App() {
  return (
    <Router>
      <Routes>
        {/* Protected Routes */}
        <Route element={<Layout />}>
          <Route path="/home" element={<PrivateRoute element={<Home />} />} />
          <Route path="/builder/:formId" element={<PrivateRoute element={<Builder />} />} />
          <Route path="/leads" element={<PrivateRoute element={<LeadsPage />} />} />
          <Route path="/integration" element={<PrivateRoute element={<Integration />} />} />
          <Route path="/dialer-logs/:formId" element={<PrivateRoute element={<DialerLogs />} />} />
          <Route path="/campaign/:id" element={<PrivateRoute element={<CampaignDetailsPage />} />} />
          <Route path="/facebookdialer/:formId" element={<PrivateRoute element={<FacebookDialer />} />} />
          <Route path="/facebook" element={<PrivateRoute element={<Facebook />} />} />
          <Route path="/linkedin" element={<PrivateRoute element={<LinkedIn />} />} />
          <Route path="/whatsapp" element={<PrivateRoute element={<WhatsAppPage />} />} />
          <Route path="/dialer/:formId" element={<PrivateRoute element={<Dialer />} />} />
        </Route>

        {/* Public Routes */}
        <Route path="/form/:id" element={<SharedDynamicForm />} />
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
      </Routes>
    </Router>
  );
}
